/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 2151:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(5772);
var THEMES = {
  MP: 'mercadopago',
  ML: 'mercadolibre'
  // ME: 'mercadoenvios',
  // MS: 'mercadoshops',
  // MA: 'mercadoads',
  // MC: 'mercadocreditos',
};
var THEMES_FLATNAMES = Object.values(THEMES);
module.exports = {
  THEMES: THEMES,
  THEMES_FLATNAMES: THEMES_FLATNAMES
};

/***/ }),

/***/ 5772:
/***/ ((module) => {

"use strict";
module.exports = require("core-js/modules/es.object.values.js");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ filteredCardsSection)
});

;// external "@babel/runtime/helpers/jsx"
const jsx_namespaceObject = require("@babel/runtime/helpers/jsx");
var jsx_default = /*#__PURE__*/__webpack_require__.n(jsx_namespaceObject);
;// external "@babel/runtime/helpers/objectSpread2"
const objectSpread2_namespaceObject = require("@babel/runtime/helpers/objectSpread2");
var objectSpread2_default = /*#__PURE__*/__webpack_require__.n(objectSpread2_namespaceObject);
;// external "@babel/runtime/helpers/objectWithoutProperties"
const objectWithoutProperties_namespaceObject = require("@babel/runtime/helpers/objectWithoutProperties");
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_namespaceObject);
;// external "@babel/runtime/helpers/slicedToArray"
const slicedToArray_namespaceObject = require("@babel/runtime/helpers/slicedToArray");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_namespaceObject);
;// external "core-js/modules/es.symbol.js"
const es_symbol_js_namespaceObject = require("core-js/modules/es.symbol.js");
;// external "core-js/modules/es.symbol.description.js"
const es_symbol_description_js_namespaceObject = require("core-js/modules/es.symbol.description.js");
;// external "core-js/modules/es.array.concat.js"
const es_array_concat_js_namespaceObject = require("core-js/modules/es.array.concat.js");
;// external "core-js/modules/es.array.filter.js"
const es_array_filter_js_namespaceObject = require("core-js/modules/es.array.filter.js");
;// external "core-js/modules/es.array.includes.js"
const es_array_includes_js_namespaceObject = require("core-js/modules/es.array.includes.js");
;// external "core-js/modules/es.array.map.js"
const es_array_map_js_namespaceObject = require("core-js/modules/es.array.map.js");
;// external "core-js/modules/es.object.to-string.js"
const es_object_to_string_js_namespaceObject = require("core-js/modules/es.object.to-string.js");
;// external "core-js/modules/es.string.includes.js"
const es_string_includes_js_namespaceObject = require("core-js/modules/es.string.includes.js");
;// external "core-js/modules/es.string.link.js"
const es_string_link_js_namespaceObject = require("core-js/modules/es.string.link.js");
;// external "core-js/modules/esnext.iterator.constructor.js"
const esnext_iterator_constructor_js_namespaceObject = require("core-js/modules/esnext.iterator.constructor.js");
;// external "core-js/modules/esnext.iterator.filter.js"
const esnext_iterator_filter_js_namespaceObject = require("core-js/modules/esnext.iterator.filter.js");
;// external "core-js/modules/esnext.iterator.map.js"
const esnext_iterator_map_js_namespaceObject = require("core-js/modules/esnext.iterator.map.js");
;// external "react"
const external_react_namespaceObject = require("react");
;// external "prop-types"
const external_prop_types_namespaceObject = require("prop-types");
;// external "classnames"
const external_classnames_namespaceObject = require("classnames");
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_namespaceObject);
;// external "@pog-ui-landings-library/framework"
const framework_namespaceObject = require("@pog-ui-landings-library/framework");
;// external "@andes-landings/layout"
const layout_namespaceObject = require("@andes-landings/layout");
;// external "@andes-landings/title"
const title_namespaceObject = require("@andes-landings/title");
;// external "@andes-landings/background"
const background_namespaceObject = require("@andes-landings/background");
;// external "@andes/tag"
const tag_namespaceObject = require("@andes/tag");
;// external "@babel/runtime/helpers/defineProperty"
const defineProperty_namespaceObject = require("@babel/runtime/helpers/defineProperty");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_namespaceObject);
;// external "core-js/modules/es.parse-float.js"
const es_parse_float_js_namespaceObject = require("core-js/modules/es.parse-float.js");
;// external "@andes/card"
const card_namespaceObject = require("@andes/card");
;// external "@andes/icons/ChevronRight24"
const ChevronRight24_namespaceObject = require("@andes/icons/ChevronRight24");
var ChevronRight24_default = /*#__PURE__*/__webpack_require__.n(ChevronRight24_namespaceObject);
;// external "@andes/icons/ChevronRight20"
const ChevronRight20_namespaceObject = require("@andes/icons/ChevronRight20");
var ChevronRight20_default = /*#__PURE__*/__webpack_require__.n(ChevronRight20_namespaceObject);
;// external "@andes-landings/image-container"
const image_container_namespaceObject = require("@andes-landings/image-container");
;// external "@andes-landings/typography"
const typography_namespaceObject = require("@andes-landings/typography");
;// external "@babel/runtime/helpers/typeof"
const typeof_namespaceObject = require("@babel/runtime/helpers/typeof");
var typeof_default = /*#__PURE__*/__webpack_require__.n(typeof_namespaceObject);
;// external "core-js/modules/es.array.for-each.js"
const es_array_for_each_js_namespaceObject = require("core-js/modules/es.array.for-each.js");
;// external "core-js/modules/es.array.iterator.js"
const es_array_iterator_js_namespaceObject = require("core-js/modules/es.array.iterator.js");
;// external "core-js/modules/es.array.some.js"
const es_array_some_js_namespaceObject = require("core-js/modules/es.array.some.js");
;// external "core-js/modules/es.date.to-iso-string.js"
const es_date_to_iso_string_js_namespaceObject = require("core-js/modules/es.date.to-iso-string.js");
;// external "core-js/modules/es.date.to-string.js"
const es_date_to_string_js_namespaceObject = require("core-js/modules/es.date.to-string.js");
;// external "core-js/modules/es.function.name.js"
const es_function_name_js_namespaceObject = require("core-js/modules/es.function.name.js");
;// external "core-js/modules/es.object.entries.js"
const es_object_entries_js_namespaceObject = require("core-js/modules/es.object.entries.js");
;// external "core-js/modules/es.object.keys.js"
const es_object_keys_js_namespaceObject = require("core-js/modules/es.object.keys.js");
// EXTERNAL MODULE: external "core-js/modules/es.object.values.js"
var es_object_values_js_ = __webpack_require__(5772);
;// external "core-js/modules/es.regexp.exec.js"
const es_regexp_exec_js_namespaceObject = require("core-js/modules/es.regexp.exec.js");
;// external "core-js/modules/es.string.iterator.js"
const es_string_iterator_js_namespaceObject = require("core-js/modules/es.string.iterator.js");
;// external "core-js/modules/es.string.replace.js"
const es_string_replace_js_namespaceObject = require("core-js/modules/es.string.replace.js");
;// external "core-js/modules/es.string.replace-all.js"
const es_string_replace_all_js_namespaceObject = require("core-js/modules/es.string.replace-all.js");
;// external "core-js/modules/es.string.starts-with.js"
const es_string_starts_with_js_namespaceObject = require("core-js/modules/es.string.starts-with.js");
;// external "core-js/modules/esnext.iterator.for-each.js"
const esnext_iterator_for_each_js_namespaceObject = require("core-js/modules/esnext.iterator.for-each.js");
;// external "core-js/modules/web.dom-collections.for-each.js"
const web_dom_collections_for_each_js_namespaceObject = require("core-js/modules/web.dom-collections.for-each.js");
;// external "core-js/modules/web.dom-collections.iterator.js"
const web_dom_collections_iterator_js_namespaceObject = require("core-js/modules/web.dom-collections.iterator.js");
;// external "core-js/modules/web.url.js"
const web_url_js_namespaceObject = require("core-js/modules/web.url.js");
;// external "core-js/modules/web.url.can-parse.js"
const web_url_can_parse_js_namespaceObject = require("core-js/modules/web.url.can-parse.js");
;// external "core-js/modules/web.url.to-json.js"
const web_url_to_json_js_namespaceObject = require("core-js/modules/web.url.to-json.js");
;// external "core-js/modules/web.url-search-params.js"
const web_url_search_params_js_namespaceObject = require("core-js/modules/web.url-search-params.js");
;// external "core-js/modules/web.url-search-params.delete.js"
const web_url_search_params_delete_js_namespaceObject = require("core-js/modules/web.url-search-params.delete.js");
;// external "core-js/modules/web.url-search-params.has.js"
const web_url_search_params_has_js_namespaceObject = require("core-js/modules/web.url-search-params.has.js");
;// external "core-js/modules/web.url-search-params.size.js"
const web_url_search_params_size_js_namespaceObject = require("core-js/modules/web.url-search-params.size.js");
;// external "core-js/modules/es.array.join.js"
const es_array_join_js_namespaceObject = require("core-js/modules/es.array.join.js");
;// ./utils/src/stringifySrcset.js





var stringifySrcset = function stringifySrcset(imagePaths) {
  var resolutions = imagePaths ? Object.keys(imagePaths) : [];
  return resolutions.map(function (resolution) {
    return "".concat(imagePaths[resolution], " ").concat(resolution, "w");
  }).join(',');
};
;// ./utils/src/rebranding-images.js




var _excluded = ["imagePath", "imagePaths", "src"];





























var REBRAND_ASSETS_STORAGE = 'https://http2.mlstatic.com/storage/pog-cm-admin/calm-assets/';
var REBRAND_ALLOWED_DOMAINS = ['https://http2.mlstatic.com/frontend-assets/growth-sellers-landings/', 'https://http2.mlstatic.com/resources/frontend/gsl-assets/', 'https://http2.mlstatic.com/storage/mgrowth-cc-blue-hero/', REBRAND_ASSETS_STORAGE];
var REBRAND_ALLOWED_EXTENSIONS = ['png', 'jpeg', 'jpg', 'webp'];
var REBRAND_SUFFIX = '--rebrand-mp';
var REBRAND_IMAGE_EXTENSION = 'webp';
var isValidRebrandDomain = function isValidRebrandDomain(url) {
  return REBRAND_ALLOWED_DOMAINS.some(function (domain) {
    return url === null || url === void 0 ? void 0 : url.startsWith(domain);
  });
};
var clearNameFile = function clearNameFile(name) {
  return {
    cleanName: name === null || name === void 0 ? void 0 : name.split('.').shift()
  };
};
var getNameFromUrl = function getNameFromUrl(url) {
  if (!URL.canParse(url)) {
    return null;
  }
  var urlObject = new URL(url);
  return {
    path: urlObject.pathname,
    name: clearNameFile(urlObject.pathname.split('/').pop()).cleanName
  };
};
var rewriteURL = function rewriteURL(url) {
  var _getNameFromUrl;
  if (!(url !== null && url !== void 0 && url.length) || !URL.canParse(url)) {
    return '';
  }
  var extension = url.split('.').pop();
  if (!REBRAND_ALLOWED_EXTENSIONS.includes(extension) || !isValidRebrandDomain(url)) {
    return url;
  }
  var dateParam = "".concat(new Date().toISOString().split('T')[0].replaceAll('-', ''));
  var filename = (_getNameFromUrl = getNameFromUrl(url)) === null || _getNameFromUrl === void 0 ? void 0 : _getNameFromUrl.name;
  var rebrandFilename = "".concat(filename).concat(REBRAND_SUFFIX, ".").concat(REBRAND_IMAGE_EXTENSION, "?d=").concat(dateParam);
  return "".concat(REBRAND_ASSETS_STORAGE).concat(rebrandFilename);
};
var rewriteImagePaths = function rewriteImagePaths(imagePaths) {
  if (!imagePaths || typeof_default()(imagePaths) !== 'object' || Object.keys(imagePaths).length < 1) {
    return {};
  }
  var clone = {};
  Object.entries(imagePaths).forEach(function (_ref) {
    var _ref2 = slicedToArray_default()(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    clone["".concat(key)] = rewriteURL(value);
  });
  return clone;
};
var getImageProperties = function getImageProperties(image) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!image || typeof_default()(image) !== 'object' || Object.keys(image) < 1) {
    return null;
  }
  var _options$setDefaultSr = options.setDefaultSrc,
    setDefaultSrc = _options$setDefaultSr === void 0 ? false : _options$setDefaultSr,
    _options$setSrcSetStr = options.setSrcSetString,
    setSrcSetString = _options$setSrcSetStr === void 0 ? false : _options$setSrcSetStr,
    _options$setImagePath = options.setImagePathsObject,
    setImagePathsObject = _options$setImagePath === void 0 ? false : _options$setImagePath,
    _options$rewriteURLs = options.rewriteURLs,
    rewriteURLs = _options$rewriteURLs === void 0 ? false : _options$rewriteURLs;
  var imagePath = image.imagePath,
    imagePaths = image.imagePaths,
    initialSrc = image.src,
    otherProps = objectWithoutProperties_default()(image, _excluded);
  var clone = objectSpread2_default()({}, otherProps);
  var paths = imagePaths !== null && imagePaths !== void 0 ? imagePaths : imagePath;
  var src = initialSrc;
  if (rewriteURLs) {
    paths = objectSpread2_default()({}, rewriteImagePaths(paths));
    if (!src && paths) {
      var imagePathsValues = Object.values(paths);
      src = imagePathsValues.length > 0 ? imagePathsValues[0] : '';
    }
    src = rewriteURL(src);
  }
  if (setDefaultSrc) {
    var defaultPath = null;
    try {
      var _Object$values;
      // defaults to second element (768px resource)
      defaultPath = ((_Object$values = Object.values(paths)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 1 ? Object.values(paths)[1] : '';
    } catch (err) {
      defaultPath = '';
    }
    clone.src = src !== null && src !== void 0 ? src : defaultPath;
  } else {
    clone.src = src;
  }
  if (setSrcSetString) {
    clone.srcset = stringifySrcset(paths);
  }
  if (setImagePathsObject) {
    clone.imagePaths = objectSpread2_default()({}, paths);
  }
  return clone;
};
;// ./utils/constants/htmlTags.js
var ALLOWED_TAGS = {
  // WARN: Andes Landings will not support 'b', 'i', 'em' tags.
  STYLED_LABEL: ['p', 'ul', 'li', 'ol', 'a', 'strong', 'b', 'i', 'em', 'br'],
  FAQS_LIST_ITEM: ['a', 'strong', 'b', 'i', 'em'],
  VOLANTA: ['p'],
  MODAL_CONTENT: ['p', 'a', 'strong', 'em', 'ul', 'ol', 'li'],
  // FIXME: Future versions may support also a and em.
  DESCRIPTION: ['p', 'strong'],
  GENERAL_TEXT: ['p', 'strong'],
  PREFOOTER: ['p'],
  SVG: ['svg', 'path', 'rect', 'g', 'defs', 'clipPath', 'circle', 'mask', 'filter', 'feFlood', 'feColorMatrix', 'feOffset', 'feBlend']
};
var ALLOWED_ATTRIBUTES = {
  LINK_ATTRIBUTES: ['href', 'name', 'target', 'class', 'data-*']
};
var DEFAULT_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.STYLED_LABEL,
  allowedAttributes: {
    a: ALLOWED_ATTRIBUTES.LINK_ATTRIBUTES
  }
};

// AL Title's Volanta
var AL_VOLANTA_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.VOLANTA
};

// AL Title's Description
var AL_DESCRIPTION_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.DESCRIPTION,
  allowedAttributes: {
    a: ALLOWED_ATTRIBUTES.LINK_ATTRIBUTES
  }
};

// Generic text
var AL_GENERIC_TEXT_SANITIZATION_CONFIG = {
  allowedTags: ALLOWED_TAGS.GENERAL_TEXT
};

/**
 * General Sanitization rules
 * These rules cover sanitization for elements across several components (like AL Title sub-elements)
 *
 * For override these rules or specific elements rules, define them inside the component folder constants.
 */

var GENERAL_SANITIZATION_RULES = {
  AL_DESCRIPTION_SANITIZATION_CONFIG: AL_DESCRIPTION_SANITIZATION_CONFIG,
  AL_GENERIC_TEXT_SANITIZATION_CONFIG: AL_GENERIC_TEXT_SANITIZATION_CONFIG,
  AL_VOLANTA_SANITIZATION_CONFIG: AL_VOLANTA_SANITIZATION_CONFIG
};
;// external "sanitize-html"
const external_sanitize_html_namespaceObject = require("sanitize-html");
var external_sanitize_html_default = /*#__PURE__*/__webpack_require__.n(external_sanitize_html_namespaceObject);
;// ./utils/src/sanitizeHTML.js


var sanitize = function sanitize(html) {
  var sanitizeConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var clean = Object.keys(sanitizeConfig).length ? external_sanitize_html_default()(html, sanitizeConfig) : external_sanitize_html_default()(html);
  return clean;
};
/* harmony default export */ const sanitizeHTML = (sanitize);
;// ./utils/src/typographyHelpers.js




var getTypographyPropsForHtmlContent = function getTypographyPropsForHtmlContent(content) {
  var sanitize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var sanitizeConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SANITIZATION_CONFIG;
  if (!content) {
    return null;
  }
  var children = sanitize ? sanitizeHTML(content, sanitizeConfig) : content;
  return {
    children: children,
    contentHtml: true
  };
};
var getTypographyPropsForALGenericText = function getTypographyPropsForALGenericText(content, customSanitizationConfig) {
  return getTypographyPropsForHtmlContent(content, true, customSanitizationConfig || GENERAL_SANITIZATION_RULES.AL_GENERIC_TEXT_SANITIZATION_CONFIG);
};
var hasParagraphTag = function hasParagraphTag(content) {
  return typeof content === 'string' && ((content === null || content === void 0 ? void 0 : content.includes('<p ')) || (content === null || content === void 0 ? void 0 : content.includes('<p>')));
};
;// external "react/jsx-runtime"
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
;// ./components/molecules/filteredCardsItem/src/FilteredCardsItem.js




var _ChevronRight, _ChevronRight2, _ChevronRight3, _ChevronRight4;





/**
 * Module dependencies
 */












var namespace = 'pog-ui-filtered-cards-item';

/**
 * Molecule
 */
var FilteredCardsItem = function FilteredCardsItem(_ref) {
  var className = _ref.className,
    id = _ref.id,
    isMobile = _ref.isMobile,
    isWebView = _ref.isWebView,
    image = _ref.image,
    title = _ref.title,
    description = _ref.description,
    highlight = _ref.highlight,
    link = _ref.link,
    onClick = _ref.onClick;
  var _ref2 = (0,framework_namespaceObject.useCalmContext)() || {},
    _ref2$isRebrand = _ref2.isRebrand,
    isRebrand = _ref2$isRebrand === void 0 ? false : _ref2$isRebrand,
    _ref2$keepImageURLs = _ref2.keepImageURLs,
    keepImageURLs = _ref2$keepImageURLs === void 0 ? false : _ref2$keepImageURLs;
  var titleRef = (0,external_react_namespaceObject.useRef)(null);
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isTitleTwoLines = _useState2[0],
    setIsTitleTwoLines = _useState2[1];
  var _ref3 = link || {},
    href = _ref3.href,
    webviewHref = _ref3.webviewHref,
    target = _ref3.target;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (highlight && titleRef.current && isMobile) {
      var lineHeight = parseFloat(window.getComputedStyle(titleRef.current).lineHeight);
      var height = titleRef.current.offsetHeight;
      var lines = height / lineHeight;
      setIsTitleTwoLines(lines > 1.5);
    } else {
      setIsTitleTwoLines(false);
    }
  }, [titleRef.current, title, highlight]);
  if (!(image !== null && image !== void 0 && image.src) || !title || !description) {
    return null;
  }
  var img = getImageProperties(image, {
    setDefaultSrc: true,
    setSrcSetString: true,
    rewriteURLs: isRebrand && !keepImageURLs
  });
  var filteredCardsItemClassNames = external_classnames_default()(namespace, className, "".concat(namespace, "--").concat(isMobile ? 'mobile' : 'desktop'));
  return /*#__PURE__*/jsx_default()("div", {
    className: filteredCardsItemClassNames,
    id: id
  }, void 0, /*#__PURE__*/jsx_default()(card_namespaceObject.Card, {
    className: "".concat(namespace, "__card"),
    paddingSize: 0,
    component: href ? 'a' : 'div',
    href: isWebView && webviewHref ? webviewHref : href,
    target: target !== null && target !== void 0 ? target : '_blank',
    onClick: onClick
  }, void 0, /*#__PURE__*/jsx_default()(card_namespaceObject.CardContent, {
    className: "".concat(namespace, "__card-content")
  }, void 0, /*#__PURE__*/jsx_default()(image_container_namespaceObject.ImageContainer, {
    img: img,
    className: "".concat(namespace, "__image")
  }), /*#__PURE__*/jsx_default()("div", {
    className: "".concat(namespace, "__card-text")
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)(typography_namespaceObject.Typography, {
    className: "".concat(namespace, "__title"),
    type: "title",
    size: "s",
    component: "h2",
    color: "link",
    ref: titleRef,
    children: [title, isMobile ? _ChevronRight || (_ChevronRight = _ChevronRight2 || (_ChevronRight2 = /*#__PURE__*/jsx_default()((ChevronRight20_default()), {}))) : _ChevronRight3 || (_ChevronRight3 = _ChevronRight4 || (_ChevronRight4 = /*#__PURE__*/jsx_default()((ChevronRight24_default()), {})))]
  }), /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(typography_namespaceObject.Typography, objectSpread2_default()({
    className: external_classnames_default()("".concat(namespace, "__description"), defineProperty_default()({}, "".concat(namespace, "__description--clamped"), isTitleTwoLines)),
    type: "body",
    size: isMobile ? 'xs' : 'l'
  }, getTypographyPropsForALGenericText(description))), highlight && /*#__PURE__*/jsx_default()(typography_namespaceObject.Typography, {
    className: "".concat(namespace, "__highlight"),
    type: "body",
    size: isMobile ? 'xs' : 'm',
    weight: "semibold"
  }, void 0, highlight)))));
};
FilteredCardsItem.defaultProps = {
  id: null,
  isMobile: false,
  isWebView: false,
  className: '',
  title: '',
  description: '',
  image: null,
  highlight: '',
  link: null
};
/* harmony default export */ const src_FilteredCardsItem = (FilteredCardsItem);
// EXTERNAL MODULE: ./utils/constants/themes.js
var themes = __webpack_require__(2151);
;// ./utils/src/marginHelpers.js

var SPACING_MARGIN_MODE = {
  ALL: 'all',
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical'
};
var setVerticalMargins = function setVerticalMargins(margins) {
  var marginTop = margins === null || margins === void 0 ? void 0 : margins.top;
  var marginBottom = margins === null || margins === void 0 ? void 0 : margins.bottom;
  return {
    marginTop: marginTop,
    marginBottom: marginBottom
  };
};
var setHorizontalMargins = function setHorizontalMargins(margins) {
  var marginLeft = margins === null || margins === void 0 ? void 0 : margins.left;
  var marginRight = margins === null || margins === void 0 ? void 0 : margins.right;
  return {
    marginLeft: marginLeft,
    marginRight: marginRight
  };
};
var setMargins = function setMargins(margins, isMobile) {
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SPACING_MARGIN_MODE.VERTICAL;
  var _ref = margins || {},
    desktop = _ref.desktop,
    mobile = _ref.mobile;
  var deviceMargins = isMobile ? mobile : desktop;
  var horizontalMargins = mode === SPACING_MARGIN_MODE.VERTICAL ? {} : setHorizontalMargins(deviceMargins);
  var verticalMargins = mode === SPACING_MARGIN_MODE.HORIZONTAL ? {} : setVerticalMargins(deviceMargins);
  return objectSpread2_default()(objectSpread2_default()({}, verticalMargins), horizontalMargins);
};
;// ./components/molecules/spacer/src/Spacer.js




/**
 * Component dependencies
 */





var Spacer_namespace = 'pog-ui-spacer';

/**
 * Component
 */

var Spacer = function Spacer(_ref) {
  var children = _ref.children,
    margins = _ref.margins,
    isMobile = _ref.isMobile;
  // Returns null if given child is not a valid React component
  if (! /*#__PURE__*/(0,external_react_namespaceObject.isValidElement)(children)) {
    return null;
  }
  var options = margins ? setMargins(margins, isMobile, SPACING_MARGIN_MODE.VERTICAL) : null;
  var styles = objectSpread2_default()({}, options);
  if (!margins || !styles.marginTop && !styles.marginBottom) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(jsx_runtime_namespaceObject.Fragment, {
      children: children
    });
  }
  return margins && /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(Spacer_namespace),
    style: styles
  }, void 0, external_react_namespaceObject.Children === null || external_react_namespaceObject.Children === void 0 ? void 0 : external_react_namespaceObject.Children.map(children, function (child) {
    return /*#__PURE__*/(0,external_react_namespaceObject.cloneElement)(child, objectSpread2_default()({}, child.props));
  }));
};
Spacer.defaultProps = {
  margins: null,
  isMobile: false
};
/* harmony default export */ const src_Spacer = (Spacer);
;// external "lodash"
const external_lodash_namespaceObject = require("lodash");
;// ./utils/constants/colorThemes.js

var colorThemes_DARK_FONT_THEMES = ['primary-grey-solid'];
var colorThemes_LIGHT_FONT_THEMES = ['primary-blue-solid', 'primary-blue-gradient', 'primary-dark-blue-gradient', 'primary-light-blue-gradient', 'secondary-blue-gradient', 'secondary-dark-blue-gradient', 'dark-blue-gradient', 'dark-gradient'];
var colorThemes_COLOR_THEMES = [].concat(colorThemes_DARK_FONT_THEMES, colorThemes_LIGHT_FONT_THEMES);
;// ./utils/constants/colorToALThemes.js
var colorToALThemes_COLOR_AVAILABLE_VALUES = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary'
};
;// ./utils/src/backgroundHelpers.js











var POG_UI_LANDINGS_BG_NAMESPACE = 'pog-ui-container__bg';
var isValidTheme = function isValidTheme(theme) {
  return theme && COLOR_THEMES.includes(theme);
};
var isDarkFontTheme = function isDarkFontTheme(theme) {
  return isValidTheme(theme) && DARK_FONT_THEMES.includes(theme);
};
var isLightFontTheme = function isLightFontTheme(theme) {
  return isValidTheme(theme) && LIGHT_FONT_THEMES.includes(theme);
};
var getThemeClass = function getThemeClass(theme) {
  return isValidTheme(theme) ? "".concat(POG_UI_LANDINGS_BG_NAMESPACE, "-").concat(theme) : '';
};
var getConcaveObject = function getConcaveObject(concaveProps) {
  if (typeof concaveProps === 'boolean') {
    return {
      top: concaveProps,
      bottom: concaveProps
    };
  }
  if (_typeof(concaveProps) === 'object' && (concaveProps !== null && concaveProps !== void 0 && concaveProps.top || concaveProps !== null && concaveProps !== void 0 && concaveProps.bottom)) {
    return {
      top: concaveProps.top,
      bottom: concaveProps.bottom
    };
  }
  return {
    top: false,
    bottom: false
  };
};
var setPaddings = function setPaddings(paddings, isMobile) {
  var _paddings$mobile, _paddings$desktop, _paddings$mobile2, _paddings$desktop2;
  var paddingTop = isMobile ? paddings === null || paddings === void 0 || (_paddings$mobile = paddings.mobile) === null || _paddings$mobile === void 0 ? void 0 : _paddings$mobile.top : paddings === null || paddings === void 0 || (_paddings$desktop = paddings.desktop) === null || _paddings$desktop === void 0 ? void 0 : _paddings$desktop.top;
  var paddingBottom = isMobile ? paddings === null || paddings === void 0 || (_paddings$mobile2 = paddings.mobile) === null || _paddings$mobile2 === void 0 ? void 0 : _paddings$mobile2.bottom : paddings === null || paddings === void 0 || (_paddings$desktop2 = paddings.desktop) === null || _paddings$desktop2 === void 0 ? void 0 : _paddings$desktop2.bottom;
  return {
    paddingTop: paddingTop,
    paddingBottom: paddingBottom
  };
};
var getBackgroundOptions = function getBackgroundOptions(background) {
  var _ref = background || {},
    theme = _ref.theme,
    gradient = _ref.gradient,
    color = _ref.color,
    _ref$concave = _ref.concave,
    concave = _ref$concave === void 0 ? false : _ref$concave,
    darkFont = _ref.darkFont;
  var options = {
    processed: true,
    theme: isValidTheme(theme) ? theme : null,
    color: color,
    gradient: gradient,
    concave: getConcaveObject(concave),
    darkFont: null
  };

  // Theme defined colors
  if (isDarkFontTheme(options.theme)) {
    return _objectSpread(_objectSpread({}, options), {}, {
      darkFont: true
    });
  }
  if (isLightFontTheme(options.theme)) {
    return _objectSpread(_objectSpread({}, options), {}, {
      darkFont: false
    });
  }

  // User defined
  if (!options.theme && isBoolean(darkFont)) {
    return _objectSpread(_objectSpread({}, options), {}, {
      darkFont: darkFont
    });
  }

  // Set Default value when neither a valid theme, nor a custom color/gradient set.
  return _objectSpread(_objectSpread({}, options), {}, {
    darkFont: !isValidTheme(options.theme) && !gradient && !color
  });
};
var getALBackgroundOptions = function getALBackgroundOptions(background, isMobile, andesTheme) {
  var isRebranding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hasBackground = !(0,external_lodash_namespaceObject.isNil)(background === null || background === void 0 ? void 0 : background.type);
  var theme = hasBackground && (background === null || background === void 0 ? void 0 : background.type) === 'hero' && !(0,external_lodash_namespaceObject.isNil)(background === null || background === void 0 ? void 0 : background.theme) ? background === null || background === void 0 ? void 0 : background.theme : null;

  // FIXME: AL has not defined how they're going to support a third theme. We keep the change focused on Heros' dark theme
  if (theme === 'dark') {
    // Dark theme uses light font as the default one, so we prevent inverted styles to interfere.
    background.inverted = false;
    background.theme = theme;
  } else if (hasBackground && theme) {
    background.theme = null;
  }
  var paddingStyles = background !== null && background !== void 0 && background.paddings ? setPaddings(background.paddings, isMobile) : null;
  var options = objectSpread2_default()(objectSpread2_default()({}, background), {}, {
    // By now we will just allow div components
    component: 'div',
    paddings: paddingStyles,
    curves: isRebranding && (background === null || background === void 0 ? void 0 : background.type) !== 'hero' ? 0 : background === null || background === void 0 ? void 0 : background.curves
  });
  var defaultsToDarkFont = !background || background.darkFont === true || !hasBackground || background.inverted || (andesTheme === themes.THEMES.ML || andesTheme === themes.THEMES.MP && isRebranding) && (background === null || background === void 0 ? void 0 : background.type) === 'hero' && theme !== 'dark';
  if (defaultsToDarkFont) {
    options.darkFont = true;
  }
  var defaultsToLightFont = hasBackground && (0,external_lodash_namespaceObject.isNil)(options.darkFont) && !background.inverted;
  if (defaultsToLightFont) {
    options.darkFont = false;
  }
  return options;
};
var getALBackgroundOptionsFromColor = function getALBackgroundOptionsFromColor(background, isMobile, andesTheme) {
  var isRebranding = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  // If color is not defined, fallbacks to previous definition
  if (isNil(background === null || background === void 0 ? void 0 : background.color)) {
    return getALBackgroundOptions(background, isMobile, andesTheme, isRebranding);
  }
  var backgroundClone = cloneDeep(background);
  var color = backgroundClone.color,
    curves = backgroundClone.curves,
    type = backgroundClone.type;

  // Fallback for curves (RJSF Forms store a -1 rather than a 0)
  if (curves < 1) {
    backgroundClone.curves = 0;
  }

  // Fallback color for unexepected values
  if (!Object.values(COLOR_AVAILABLE_VALUES).includes(color) || type !== 'hero' && color === COLOR_AVAILABLE_VALUES.TERTIARY) {
    backgroundClone.color = null;
  }
  switch (backgroundClone.color) {
    case COLOR_AVAILABLE_VALUES.PRIMARY:
      backgroundClone.inverted = false;
      backgroundClone.darkFont = andesTheme !== THEMES.MP && type === 'hero' || andesTheme === THEMES.MP && isRebranding && type === 'hero';
      backgroundClone.theme = null;
      break;
    case COLOR_AVAILABLE_VALUES.SECONDARY:
      backgroundClone.inverted = true;
      backgroundClone.darkFont = true;
      backgroundClone.theme = null;
      break;
    case COLOR_AVAILABLE_VALUES.TERTIARY:
      backgroundClone.inverted = false;
      backgroundClone.darkFont = false;
      backgroundClone.theme = 'dark';
      break;
    default:
      break;
  }
  return getALBackgroundOptions(backgroundClone, isMobile, andesTheme, isRebranding);
};
;// ./utils/src/titleHelpers.js


var titleHelpers_AL_VOLANTA_SANITIZATION_CONFIG = GENERAL_SANITIZATION_RULES.AL_VOLANTA_SANITIZATION_CONFIG,
  titleHelpers_AL_DESCRIPTION_SANITIZATION_CONFIG = GENERAL_SANITIZATION_RULES.AL_DESCRIPTION_SANITIZATION_CONFIG;
var getTypographyPropsForALVolanta = function getTypographyPropsForALVolanta(volanta, customSanitizationConfig) {
  return getTypographyPropsForHtmlContent(volanta, true, customSanitizationConfig || titleHelpers_AL_VOLANTA_SANITIZATION_CONFIG);
};
var getTypographyPropsForALDescription = function getTypographyPropsForALDescription(description, customSanitizationConfig) {
  var descriptionAsObject = getTypographyPropsForHtmlContent(description, true, customSanitizationConfig || titleHelpers_AL_DESCRIPTION_SANITIZATION_CONFIG);
  if (hasParagraphTag(descriptionAsObject === null || descriptionAsObject === void 0 ? void 0 : descriptionAsObject.children)) {
    descriptionAsObject.component = 'div';
  }
  return descriptionAsObject;
};
;// external "core-js/modules/es.number.constructor.js"
const es_number_constructor_js_namespaceObject = require("core-js/modules/es.number.constructor.js");
;// external "core-js/modules/es.number.is-nan.js"
const es_number_is_nan_js_namespaceObject = require("core-js/modules/es.number.is-nan.js");
;// ./components/hooks/useOnScreen.js


var useOnScreen = function useOnScreen(ref) {
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _useState = (0,external_react_namespaceObject.useState)(false),
    _useState2 = slicedToArray_default()(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var observer = (0,external_react_namespaceObject.useMemo)(function () {
    if (typeof IntersectionObserver !== 'function') {
      setIsVisible(false);
      return null;
    }
    return new IntersectionObserver(function (_ref) {
      var _ref2 = slicedToArray_default()(_ref, 1),
        entry = _ref2[0];
      setIsVisible(entry.isIntersecting);
    }, {
      threshold: threshold
    });
  }, [ref]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (observer) {
      if (ref !== null && ref !== void 0 && ref.current) {
        observer.observe(ref.current);
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
  return {
    isVisible: isVisible,
    observer: observer
  };
};
;// ./components/hooks/useTrackShow.js





var useTrackShow = function useTrackShow(refModule, tracking, sectionMetadata) {
  var requireDispatchCall = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var _ref = tracking || {},
    onShow = _ref.onShow;
  var refElement = onShow !== null && onShow !== void 0 && onShow.enabled ? refModule : null;
  var customThreshold = Number(onShow === null || onShow === void 0 ? void 0 : onShow.threshold);
  var threshold = 0.9;
  if (!Number.isNaN(customThreshold) && customThreshold >= 0.0 && customThreshold <= 1.0) {
    threshold = customThreshold;
  }
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackShow = (0,framework_namespaceObject.getShowTrackingFn)(trackingHandler);
  var _useOnScreen = useOnScreen(refElement, threshold),
    isVisible = _useOnScreen.isVisible,
    observer = _useOnScreen.observer;
  (0,external_react_namespaceObject.useEffect)(function () {
    if (isVisible) {
      trackShow(sectionMetadata);
      if (observer) {
        observer.disconnect();
      }
    }
  }, [isVisible]);
  if (requireDispatchCall) {
    var sendTrackShow = function sendTrackShow(data) {
      trackShow(data);
    };
    return {
      isVisible: isVisible,
      sendTrackShow: sendTrackShow
    };
  }
  return {
    isVisible: isVisible
  };
};
/* harmony default export */ const hooks_useTrackShow = (useTrackShow);
;// ./components/sections/filteredCardsSection/src/constants/index.js
var MIN_CARD_ITEMS = 2;
var DEFAULT_CARD_ID = 'filtered-cards-item';
var DEFAULT_TAG_ID = 'filtered-cards-tag';
;// ./components/sections/filteredCardsSection/src/FilteredCardsSection.js




var FilteredCardsSection_excluded = ["inverted", "paddings"];












/**
 * Component dependencies
 */
















var FilteredCardsSection_namespace = 'pog-ui-filtered-cards-section';
var CARD_LINK = framework_namespaceObject.TRACKING_TRIGGERS.CARD_LINK;

/**
 * FilteredCardsSection
 */

var FilteredCardsSection = function FilteredCardsSection(_ref) {
  var _filters$;
  var id = _ref.id,
    className = _ref.className,
    isMobile = _ref.isMobile,
    isWebView = _ref.isWebView,
    head = _ref.head,
    filters = _ref.filters,
    allFilterLabel = _ref.allFilterLabel,
    cards = _ref.cards,
    background = _ref.background,
    margins = _ref.margins,
    andesTheme = _ref.andesTheme,
    tracking = _ref.tracking,
    sectionMetadata = _ref.sectionMetadata;
  var _ref2 = (0,framework_namespaceObject.useCalmContext)() || {},
    _ref2$isRebrand = _ref2.isRebrand,
    isRebrand = _ref2$isRebrand === void 0 ? false : _ref2$isRebrand;
  var trackingHandler = (0,framework_namespaceObject.useTracking)();
  var trackClick = (0,framework_namespaceObject.getDefaultEventTrackingFn)(trackingHandler);
  var moduleRef = (0,external_react_namespaceObject.useRef)(null);
  hooks_useTrackShow(moduleRef, tracking, sectionMetadata);
  var _ref3 = cards || {},
    items = _ref3.items;
  var initialFilterValue = allFilterLabel ? '' : filters === null || filters === void 0 || (_filters$ = filters[0]) === null || _filters$ === void 0 ? void 0 : _filters$.value;
  var _useState = (0,external_react_namespaceObject.useState)(initialFilterValue),
    _useState2 = slicedToArray_default()(_useState, 2),
    activeFilter = _useState2[0],
    setActiveFilter = _useState2[1];
  var _useState3 = (0,external_react_namespaceObject.useState)(items),
    _useState4 = slicedToArray_default()(_useState3, 2),
    selectedCards = _useState4[0],
    setSelectedCards = _useState4[1];
  var applyFilter = function applyFilter(filter) {
    setActiveFilter(filter);
    if (filter === '') {
      setSelectedCards(items);
      return;
    }
    var filteredCards = items.filter(function (card) {
      return card.filters.includes(filter);
    });
    setSelectedCards(filteredCards);
  };
  (0,external_react_namespaceObject.useEffect)(function () {
    if (items !== null && items !== void 0 && items.length) {
      setSelectedCards(items);
    }
  }, [items]);
  (0,external_react_namespaceObject.useEffect)(function () {
    if (!allFilterLabel && activeFilter) {
      applyFilter(activeFilter);
    }
  }, [allFilterLabel, activeFilter]);
  var hasInvalidItems = !(items !== null && items !== void 0 && items.length) || items.length < MIN_CARD_ITEMS;
  if (hasInvalidItems || !(head !== null && head !== void 0 && head.title)) {
    return null;
  }
  var _getALBackgroundOptio = getALBackgroundOptions(background, isMobile, andesTheme, isRebrand),
    inverted = _getALBackgroundOptio.inverted,
    paddings = _getALBackgroundOptio.paddings,
    backgroundOptions = objectWithoutProperties_default()(_getALBackgroundOptio, FilteredCardsSection_excluded);
  var hasBackground = (backgroundOptions === null || backgroundOptions === void 0 ? void 0 : backgroundOptions.type) && inverted;
  var getItemConfig = function getItemConfig(card, index) {
    var _card$link, _card$link2;
    if (!((_card$link = card.link) !== null && _card$link !== void 0 && _card$link.href)) {
      return null;
    }
    var cardLinkProps = objectSpread2_default()({}, card);
    var trackdata = (0,framework_namespaceObject.buildTracks)(card === null || card === void 0 || (_card$link2 = card.link) === null || _card$link2 === void 0 ? void 0 : _card$link2.trackdata, "".concat(CARD_LINK, " ").concat(index + 1), sectionMetadata);
    cardLinkProps = objectSpread2_default()(objectSpread2_default()({}, cardLinkProps), {}, {
      onClick: function onClick(ev) {
        trackClick(ev, trackdata);
      }
    });
    return cardLinkProps;
  };
  var component = /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()(FilteredCardsSection_namespace, className, isMobile ? "".concat(FilteredCardsSection_namespace, "--mobile") : "".concat(FilteredCardsSection_namespace, "--desktop"))
  }, void 0, /*#__PURE__*/jsx_default()(layout_namespaceObject.Grid, {
    container: true,
    component: "div",
    className: external_classnames_default()(FilteredCardsSection_namespace, className, isMobile ? "".concat(FilteredCardsSection_namespace, "--mobile") : "".concat(FilteredCardsSection_namespace, "--desktop"))
  }, void 0, (head === null || head === void 0 ? void 0 : head.title) && /*#__PURE__*/jsx_default()(layout_namespaceObject.GridItem, {
    col: 12,
    colSt: 1
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(title_namespaceObject.TitleBase, objectSpread2_default()(objectSpread2_default()({}, head), {}, {
    misc: head.misc,
    title: head.title,
    volanta: getTypographyPropsForALVolanta(head === null || head === void 0 ? void 0 : head.volanta),
    description: getTypographyPropsForALDescription(head === null || head === void 0 ? void 0 : head.description),
    align: "center",
    className: external_classnames_default()("".concat(FilteredCardsSection_namespace, "__head"), head === null || head === void 0 ? void 0 : head.className)
  })), (filters === null || filters === void 0 ? void 0 : filters.length) > 0 && /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()("".concat(FilteredCardsSection_namespace, "__tags"))
  }, void 0, allFilterLabel && /*#__PURE__*/jsx_default()(tag_namespaceObject.TagChoice, {
    label: allFilterLabel,
    className: "".concat(FilteredCardsSection_namespace, "__pill"),
    selected: activeFilter === '',
    onClick: function onClick() {
      return applyFilter('');
    }
  }, "".concat(DEFAULT_TAG_ID, "-all")), filters === null || filters === void 0 ? void 0 : filters.map(function (_ref4, index) {
    var label = _ref4.label,
      value = _ref4.value;
    return /*#__PURE__*/jsx_default()(tag_namespaceObject.TagChoice
    // eslint-disable-next-line react/no-array-index-key
    , {
      label: label,
      className: "".concat(FilteredCardsSection_namespace, "__pill"),
      selected: activeFilter === (value !== null && value !== void 0 ? value : initialFilterValue),
      onClick: function onClick() {
        return applyFilter(value);
      }
    }, "".concat(DEFAULT_TAG_ID, "-").concat(index));
  }))), /*#__PURE__*/jsx_default()(layout_namespaceObject.GridItem, {
    col: 12,
    colSt: 1
  }, void 0, /*#__PURE__*/jsx_default()("div", {
    className: external_classnames_default()("".concat(FilteredCardsSection_namespace, "__cards"))
  }, void 0, selectedCards.map(function (card, index) {
    var key = card.id || "".concat(DEFAULT_CARD_ID, "-").concat(index);
    var itemConfig = getItemConfig(card, index);
    return /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(src_FilteredCardsItem, objectSpread2_default()({
      isMobile: isMobile,
      isWebView: isWebView,
      id: key,
      title: card === null || card === void 0 ? void 0 : card.title,
      description: card === null || card === void 0 ? void 0 : card.description,
      image: card === null || card === void 0 ? void 0 : card.image,
      highlight: card === null || card === void 0 ? void 0 : card.highlight,
      link: card === null || card === void 0 ? void 0 : card.link
    }, itemConfig), key);
  })))));
  return /*#__PURE__*/jsx_default()(src_Spacer, {
    isMobile: isMobile,
    margins: margins
  }, void 0, /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsxs)("div", {
    id: id,
    ref: moduleRef,
    className: "".concat(FilteredCardsSection_namespace, "__container"),
    children: [hasBackground && /*#__PURE__*/(0,jsx_runtime_namespaceObject.jsx)(background_namespaceObject.Background, objectSpread2_default()(objectSpread2_default()({}, backgroundOptions), {}, {
      style: paddings,
      inverted: inverted,
      curves: 0,
      children: component
    })), !hasBackground && /*#__PURE__*/jsx_default()("div", {}, void 0, component)]
  }));
};

/**
 * Prop types
 */

FilteredCardsSection.defaultProps = {
  andesTheme: themes.THEMES.MP,
  className: '',
  head: {
    title: '',
    weight: 'h2',
    misc: true
  },
  allFilterLabel: null,
  background: null,
  id: null,
  isMobile: false,
  isWebView: false,
  margins: null,
  tracking: null
};

/**
 * Export component
 */
/* harmony default export */ const src_FilteredCardsSection = (FilteredCardsSection);
;// ./packages/filteredCardsSection/src/FilteredCardsSection.js

/* harmony default export */ const filteredCardsSection_src_FilteredCardsSection = (src_FilteredCardsSection);
;// ./packages/filteredCardsSection/index.js
/**
 * Export FilteredCardsSection
 */

/* harmony default export */ const filteredCardsSection = (filteredCardsSection_src_FilteredCardsSection);
})();

module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=index.production.js.map